import { Box, Typography, TextField, Button, Modal } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "react-i18next";
import { modalStyle2 } from "./ModalComponentRecommendations.jsx";
import { useState } from "react";

export default function ReasoningModalRecommendations({
  reasonDialogOpen,
  setReasonDialogOpen,
  action,
  setAction,
  reason,
  setReason,
  setConfirmationOpen,
  onContinueWithoutReason,
  loading,
}) {
  const { t } = useTranslation("recommendations");
  const actionLabel = t(`buttons.${action}`);

  return (
    <Modal
      open={reasonDialogOpen}
      onClose={() => setReasonDialogOpen(false)}
      aria-labelledby="reasoning-title"
    >
      <Box sx={modalStyle2}>
        <Typography variant="h6" id="reasoning-title">
          {t("reasoningModal.title", { action: actionLabel })}
        </Typography>
        <TextField
          multiline
          rows={4}
          fullWidth
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder={t("reasoningModal.placeholder")}
          sx={{ mt: 2 }}
        />
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2, gap: 2 }}>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setReasonDialogOpen(false);
              setAction("");
            }}
          >
            {t("buttons.cancel")}
          </Button>
          {reason && (
            <Button
              variant="contained"
              color="success"
              disabled={reason.trim().length < 4}
              onClick={() => {
                setReasonDialogOpen(false);
                setConfirmationOpen(true);
              }}
            >
              {t("buttons.ok")}
            </Button>
          )}
          {!reason && (
            <LoadingButton
              loading={loading}
              loadingPosition="end"
              disabled={!action}
              endIcon={<ArrowForwardIcon />}
              onClick={onContinueWithoutReason}
            >
              {t("buttons.continueWithoutReason")}
            </LoadingButton>
          )}
        </Box>
      </Box>
    </Modal>
  );
}
